import {
  billingCycleDependBasePlanTypeList,
  dependMeetingPlanTypeList,
  licenseDependBasePlanTypeList,
  planTypes,
} from '@/common/constants';
import { defaultMapper } from "@/common/service/default-mapper"

const WebinarKey = [
    // 'webinar100',
    'webinar500',
    'webinar1000',
    'webinar3000',
    'webinar5000',
    'webinar10000',
]

export default (planMapJSON) => {
    return WebinarKey.filter(key => !planMapJSON?.disablePlanCategoryList.includes(key)).reduce((pre, key) => {
        return [
            ...defaultMapper(planMapJSON[key], planTypes.WEBINAR).map(item => ({
                ...item,
                participants: planMapJSON[key].participants,
                capacity: planMapJSON[key].participants,
                typeNameKey: 'billing.webinar.title',
                planNameKey: 'billing.webinar.title',
                dependBasePlanTypeList: dependMeetingPlanTypeList,
                billingCycleDependBasePlanTypeList,
                licenseDependBasePlanTypeList,
            })),
            ...pre,
        ]
    }, []);
}
